TYPE_VA_SERVICE